<div class="tw-w-full tw-h-full tw-relative" [appScrollLock]="viewsDropdown">
  @if (hasSelection()) {
    <div
      class="tw-w-full tw-h-full tw-flex tw-gap-1 tw-items-center tw-rounded-2xl tw-shadow-elevation-card tw-px-6 xs:tw-px-4 tw-bg-dt-surface-card tw-cursor-pointer border-gradient-neuomorphic hover:tw-bg-dt-surface-elevated"
      [ngClass]="{
        'hover-border-past border-active-past':
          viewsService.currentView() === View.PAST && viewsDropdown,
        'hover-border-today border-active-today':
          viewsService.currentView() === View.TODAY && viewsDropdown,
        'hover-border-future border-active-future':
          viewsService.currentView() === View.FUTURE && viewsDropdown,
        'hover-border-past': viewsService.currentView() === View.PAST && !viewsDropdown,
        'hover-border-today': viewsService.currentView() === View.TODAY && !viewsDropdown,
        'hover-border-future': viewsService.currentView() === View.FUTURE && !viewsDropdown,
      }"
      (click)="openFilterDialog()"
      appKeyboardActivatable
      [appKeyboardActivatableExpanded]="viewsDropdown"
      (appKeyboardActivatableActivate)="openFilterDialog()"
      data-testid="views-filter-button"
    >
      <div class="tw-w-full tw-h-full tw-flex tw-items-center">
        <div
          class="tw-flex tw-w-full tw-h-full tw-items-center tw-cursor-pointer tw-gap-2 tw-text-base sm:tw-text-sm"
        >
          <div class="tw-font-medium tw-text-dt-text-secondary">{{ "filter" | i18n }}</div>
          <div
            class="tw-flex tw-w-full tw-h-full tw-gap-2 filter-scrollbar tw-overflow-x-auto tw-items-center"
          >
            @for (pill of filterPills(); track pill.label) {
              <div
                class="tw-flex tw-items-center tw-gap-1 tw-py-1.5 tw-pl-3 tw-pr-2 tw-rounded-full tw-text-xs tw-shadow-card-elevated tw-h-fit tw-bg-color-action-primary tw-text-color-text-on-action"
              >
                <span>{{ pill.label | i18n }}</span>
                <span
                  class="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-elevated tw-text-[11px] tw-font-bold tw-text-color-text-action"
                >
                  {{ pill.count }}
                </span>
              </div>
            }
          </div>
          <icon name="view-toggle" [size]="6" [currentColor]="'neutral-600'"></icon>
        </div>
      </div>
    </div>
  }
</div>
